import React, { Component } from 'react';
import * as API from './api.js';
import './style.css';
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import AeroGCSInactive from './sidebaricon/AeroGCSInactive.png';
import InMaintenanceIcon from './InMaintenanceIcon.svg';
import RPAS from './rpas.png';
import { addUserAnalytic, updateOutTime, checkSubscriptionAndStorage } from './ReusableComponents/reusableFunctions.js';
import { getActiveTeam } from './Teams/index.js';
import SubscriptionExpireModal from './subscription/Reusable/SubscriptionExpireModal.js';
import AppConstants from './AppConstants.js';
import LoaderComponent from './ReusableComponents/LoaderComponent.js';
import CsvDownload from 'react-json-to-csv';
import TableView from './ReusableComponents/TableView/TableView.js';
import { withRouter } from 'react-router-dom';
import { BreadCrumbs } from './ReusableComponents/BreadCrumbs.js';
import SearchHeader from './ReusableComponents/SearchHeader/SearchHeader.js';
import { debounnceFn } from '././ReusableComponents/reusableFunctions.js'
import RegisterDronePopup from './RegisterDronePopup.js';
import TableViewPagination from './ReusableComponents/TableView/TableViewPagination.js';
import { ManageDroneAccess } from './Teams/ManageDroneAccess.js';
import Select from 'react-dropdown-select';
import { ActivityPopup } from './ReusableComponents/ActivityPopup.js';

class DrnMgmtDrones extends Component {
    constructor(props) {
        super(props);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.getDronesData = this.getDronesData.bind(this);
    }
    state = {
        user: {},
        type: "",
        organizations: [],
        drones: [],
        unregisteredAssignedDrones: [],
        sortType: 'Last Modified',
        debounceSearchFn: undefined,
        droneLoading: false,
        sortTypeName: false,
        sortTypeDate: false,
        sidebarMode: (this.props.location.state ? this.props.location.state.sidebarMode : "shrunk"),
        showSubscriptionExpirePopup: false,
        loading: true,
        droneCount: 0,
        registeredDroneCount: 0,
        unregisterDroneCount: 0,
        inMaintenanceDroneCount: 0,
        filter: {
            searchString: '',
            fromDateTime: undefined,
            toDateTime: undefined,
            orderBy: 'last_flight_date',
            orderType: 'DESC',
            pageSize: 15,
            pageNumber: 1,
            droneType: { label: "All", value: "all_drones" }
        },
        outId: "",
        statusChangeDrone: undefined,
        activityPopup: undefined
    }

    parentSidebarSwitch = () => {
        this.setState((state) => ({
            ...state,
            sidebarMode: (state.sidebarMode == "shrunk" ? "expanded" : "shrunk")
        }))
    }

    handleFilterChange = (newFilter, updatedField) => {
        const { fromDateTime, toDateTime } = newFilter;
        const isoFromDateTime = fromDateTime === undefined ? undefined : new Date(fromDateTime).toISOString();
        const isoToDateTime = toDateTime === undefined ? undefined : new Date(toDateTime).toISOString();
        this.setState({
            filter: {
                ...this.state.filter,
                ...newFilter,
                fromDateTime: fromDateTime === undefined || toDateTime === undefined ? undefined : isoFromDateTime,
                toDateTime: fromDateTime === undefined || toDateTime === undefined ? undefined : isoToDateTime,
                pageNumber: updatedField == "fromDateTime" || updatedField == "toDateTime" ? 1 : this.state.filter.pageNumber
            }
        }, () => {
            this.setFiltersToLocalStorage();

            if (updatedField === "searchString") {
                this.setState({
                    filter: {
                        ...this.state.filter,
                        pageNumber: 1,
                    }
                }, () => {
                    this.setFiltersToLocalStorage();
                    this.debounnceSearchFn();
                })
            } else {
                this.getDronesData();
            }
        });
    }

    handleDownloadDronesCSV = async () => {
        try {
            await API.downloadDronesCSV(this.state.filter)
        } catch (err) {
            console.log(err)
        }
    }

    setFiltersToLocalStorage = () => {
        localStorage.setItem("drones_page_filters", JSON.stringify(this.state.filter))
    }

    getFiltersFromLocalStorage = () => {
        let savedFilters = localStorage.getItem("drones_page_filters");
        if (savedFilters) {
            let parsedFilters = JSON.parse(savedFilters);
            return parsedFilters
        } else {
            return {
                searchString: '',
                fromDateTime: undefined,
                toDateTime: undefined,
                orderBy: 'last_flight_date',
                orderType: 'DESC',
                pageSize: 15,
                pageNumber: 1,
                droneType: { label: "All", value: "all_drones" }
            };
        }
    }

    getDronesData = () => {
        this.setState((state) => ({
            ...state,
            droneLoading: true,
        }))

        API.getGCSDrones(this.state.filter).then((result) => {
            this.setState(state => ({
                ...state,
                droneLoading: false,
                drones: result.drones,
                droneCount: result.droneCount,
                registeredDroneCount: result.registeredCount || 0,
                unregisterDroneCount: result.unregisteredCount || 0,
                inMaintenanceDroneCount: result.isInMaintenanceCount || 0,
                unregisteredAssignedDrones: result.unregisteredAssignedDrones,
                loading: false
            }))
        }).catch(err => {
            this.setState((state) => ({
                ...state,
                droneLoading: false,
            }))
        })
    }

    componentWillUnmount() { updateOutTime(this.state.outId) }

    componentWillMount() {
        this.debounnceSearchFn = debounnceFn(this.getDronesData, 700);
        document.title = "Drones - Device Management";
        let dronesFilters = this.getFiltersFromLocalStorage();
        this.setState((state) => ({
            ...state,
            filter: dronesFilters
        }))
        addUserAnalytic(this.props.location.pathname).then(id => this.setState({ outId: id }))
        getActiveTeam().then(activeTeam => {
            this.setState({
                activeTeam
            }, () => {
                checkSubscriptionAndStorage(AppConstants.SERVICES.AEROGCS).then(data => {
                    if (data.error || data.storageExceed || data.subscriptionExpire || !data.isValidStoragePlan || data.isExpired)
                        this.setState({ showSubscriptionExpirePopup: { ...data, user: this.props?.location?.state?.user } });
                    else this.setState({ showSubscriptionExpirePopup: false, infoPopup: true });
                })

                const isoDefaultFromDateTime = this.state.filter.fromDateTime !== undefined ? new Date(this.state.filter.fromDateTime).toISOString() : undefined;
                const isoDefaultToDateTime = this.state.filter.fromDateTime !== undefined ? new Date(this.state.filter.toDateTime).toISOString() : undefined;

                // Update filter state with default values
                this.setState(prevState => ({
                    filter: {
                        ...prevState.filter,
                        fromDateTime: isoDefaultFromDateTime,
                        toDateTime: isoDefaultToDateTime
                    }
                }));

                if (this.props.location.state) {
                    let { user, type } = this.props.location.state;
                    this.setState((state) => ({
                        ...state,
                        user,
                        type
                    }), () => { this.getDronesData(); })
                } else {
                    API.getUserType().then(([blah, type, user]) => {
                        this.setState((state) => ({
                            ...state,
                            user,
                            type
                        }), () => { this.getDronesData(); })
                    }, (e) => {
                        window.location.replace("/login");
                    })
                }
            })
        })
    }

    closeActivityPopup = () => {
        this.setState((state) => ({
            ...state,
            activityPopup: undefined,
            statusChangeDrone: undefined,
        }))
    }

    unregister = () => {
        this.setState((state) => ({
            activityPopup: {
                open: true,
                msg: this.state.statusChangeDrone.is_registered ? "Unregistering drone, please Wait..." : "Registering drone, please Wait...",
                item: "WAIT",
                icon: "WAIT",
            }
        }), () => {
            API.updateGCSDrones(this.state.statusChangeDrone.drone_id, !this.state.statusChangeDrone.is_registered)
                .then((results) => {
                    this.setState((prevState) => ({
                        ...prevState,
                        activityPopup: {
                            open: true,
                            msg: this.state.statusChangeDrone.is_registered ? "Drone unregistered successfully." : "Drone registered successfully.",
                            item: "COMPLETE",
                            icon: "COMPLETE",
                        }
                    }), () => {
                        this.getDronesData()
                    });
                })
                .catch((e) => {
                    this.setState((state) => ({
                        activityPopup: {
                            open: true,
                            msg: e.message || 'Error',
                            item: "ERROR",
                            icon: "ERROR",
                        }
                    }))
                    try {
                        console.log(JSON.stringify(e));
                    } catch (exception) {
                        console.log(e);
                    }
                });
        })

    };

    render() {
        let { user, type, customerDisplay, organizations, sidebarMode } = this.state

        return (user.username ? <div className="wrapper">
            {this.state.showRegisterDronePopup && <RegisterDronePopup onRequestClose={(success) => {
                this.setState({ showRegisterDronePopup: false }, () => {
                    if (success) {
                        // this.getDronesData();
                    }
                })
            }} />}
            <ManageDroneAccess
                drone={this.state.selectedManageDroneAccess}
                closeManageAccess={() => {
                    this.setState({
                        selectedManageDroneAccess: false,
                        //     selectedProjectData: undefined
                    })
                }}
                senderData={user}
            // propsData={this.state.selectedProjectData}
            />
            <div className="right-content-new"
                onClick={
                    () => {
                        this.setState((state) => ({
                            ...state, sidebarMode: 'shrunk'
                        }))
                    }
                }
            >
                <div className="top-bar-new">
                    <div className="top-bar-text-new">
                        <BreadCrumbs
                            data={[
                                {
                                    displayName: "Home",
                                    pathname: "/",
                                    state: {
                                        user
                                    }
                                },
                                {
                                    displayName: 'Drones',
                                }
                            ]} />
                    </div>
                </div>
                <ActivityPopup
                    item={this.state.activityPopup?.item}
                    open={this.state.activityPopup?.open}
                    icon={this.state.activityPopup?.icon}
                    msg={this.state.activityPopup?.msg}
                    close={() => { this.closeActivityPopup() }}
                    onClickOk={() => {
                        this.unregister()
                    }}
                />

                {this.state.loading ? <LoaderComponent height="90%" width="100%" />
                    : <div className="main-content-new">
                        {this.state.showSubscriptionExpirePopup ?
                            <SubscriptionExpireModal
                                data={this.state.showSubscriptionExpirePopup}
                            /> : <></>}
                        {this.state.activeTeam.isOwner ? <>
                            {this.state.loading ? <LoaderComponent height={'90vh'} />
                                : <>
                                    <div>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "20px", paddingTop: "17px" }}>
                                            <div style={{ display: 'flex', gap: "10px", alignItems: 'center' }}>
                                                <div className="reusable-table-title">{`Drones (${this.state.droneCount || 0})`}</div>
                                                <div style={{ display: "flex", gap: "5px", alignItems: "center", marginLeft: '15px' }}>
                                                    <div style={{ backgroundColor: '#3988F9', height: '16px', width: '16px', borderRadius: '4px' }} />
                                                    <div>Register: {this.state.registeredDroneCount || 0}</div>
                                                </div>
                                                <div style={{ display: "flex", gap: "5px", alignItems: "center", marginLeft: '15px' }}>
                                                    <div style={{ backgroundColor: '#6C757D', height: '16px', width: '16px', borderRadius: '4px' }} />
                                                    <div>Unregister: {this.state.unregisterDroneCount || 0}</div>
                                                </div>
                                                <div style={{ display: "flex", gap: "5px", alignItems: "center", marginLeft: '15px' }}>
                                                    <div style={{ backgroundColor: '#FFA500', height: '16px', width: '16px', borderRadius: '4px' }} />
                                                    <div>In Maintenance: {this.state.inMaintenanceDroneCount || 0}</div>
                                                </div>
                                            </div>
                                            {this.state.drones.length > 0 && this.state.activeTeam.isOwner &&
                                                <button className="new-button new-btn-active new-btn-lg download-data-btn" onClick={this.handleDownloadDronesCSV}>Download Data</button>
                                            }
                                        </div>
                                        <SearchHeader
                                            defaultFromDate={this.state.filter.fromDateTime}
                                            defaultToDate={this.state.filter.toDateTime}
                                            isShowDateTimePicker={true}
                                            searchString={this.state.filter.searchString}
                                            placeholder={"Search drones.."}
                                            onFilterDataChange={(newFilter, updatedField) => {
                                                this.handleFilterChange(newFilter, updatedField)
                                            }}
                                            middleComponent={
                                                <Select
                                                    placeholder="Select Drone Type"
                                                    options={[
                                                        {
                                                            label: "All",
                                                            value: "all_drones"
                                                        },
                                                        {
                                                            label: 'Faulty Flow Meter',
                                                            value: 'faulty_flow_meter'
                                                        },
                                                        {
                                                            label: 'In Maintenance',
                                                            value: 'is_in_maintenance'
                                                        }
                                                    ]}
                                                    values={[this.state.filter.droneType]}
                                                    className="custom_dropdown"
                                                    style={{
                                                        borderRadius: "7px",
                                                        height: "42px"
                                                    }}
                                                    searchable={true}
                                                    onChange={(values) => {
                                                        const selectedValue = values[0]
                                                        this.setState({
                                                            filter: {
                                                                ...this.state.filter,
                                                                droneType: selectedValue
                                                            }
                                                        }, () => {
                                                            this.setFiltersToLocalStorage();
                                                            this.getDronesData();
                                                        });
                                                    }}
                                                />
                                            }
                                        />
                                    </div>

                                    <div style={{ position: 'relative', height: "83%", marginTop: '10px' }} className={"drone_mag_table_height"}>
                                        <TableView
                                            pageNumber={this.state.filter.pageNumber}
                                            columns={[
                                                { Header: '', accessor: 'maintencance_icon', isSortable: false, isCenter: true, onHoverText: 'Drone is in maintenance' },
                                                { Header: 'Drone ID', accessor: 'drone_id', width: '16%', },
                                                { Header: 'Drone UIN', accessor: 'uin', width: '11%', },
                                                { Header: 'Drone Name', accessor: 'drone_name', width: '11%', isSortable: true },
                                                { Header: 'Synced Flights', accessor: 'flight_count', width: '11%', isCenter: true, isSortable: true },
                                                { Header: 'Unsynced Flights', accessor: 'offline_flights_count', width: '12%', isCenter: true, isSortable: true },
                                                { Header: 'Last Activity', accessor: 'last_flight_date', width: '12%', isDate: true, isSortable: true },
                                                { Header: 'Created Date', accessor: 'registered_date', width: '12%', isSortable: true, isDate: true, },
                                                { Header: 'Status', accessor: 'registeredStatus', width: '12%', isToggle: true, isSortable: true },
                                            ]}
                                            onClickRow={(drone) => {
                                                delete drone.registeredStatus
                                                delete drone.maintencance_icon
                                                this.props.history.push(`/aerogcsenterprise/drone_details`, { user, drone: drone })
                                            }}
                                            data={this.state.drones.map((d) => {
                                                return ({
                                                    ...d,
                                                    maintencance_icon: d.is_in_maintenance ? <img style={{ width: "20px", height: '20px' }} src={InMaintenanceIcon} /> : undefined,
                                                    registeredStatus: {
                                                        text: d.is_registered ? 'Register' : 'Unregister', value: d.is_registered ? 'Register' : 'Unregister',
                                                        onClick: (drone) => {
                                                            this.setState({
                                                                statusChangeDrone: drone,
                                                                activityPopup: {
                                                                    open: true,
                                                                    msg: drone.is_registered ? 'Are you sure you want to unregister this drone ?' : 'Are you sure you want to register this drone ?',
                                                                    item: "WARNING",
                                                                    icon: "WARNING",
                                                                }
                                                            })
                                                        }
                                                    }
                                                })
                                            }) || []}
                                            user={user}
                                            isLoading={this.state.droneLoading}
                                            // headingLeft="Drones"
                                            count={this.state.droneCount}
                                            onStateChange={(changedState) => {
                                                console.log("changedState", changedState)
                                                this.setState({
                                                    filter: {
                                                        ...this.state.filter,
                                                        pageNumber: changedState.pageNumber,
                                                        ...(changedState.orderBy
                                                            ? { orderBy: changedState.orderBy === "registeredStatus" ? "is_registered" : changedState.orderBy }
                                                            : {}),
                                                        ...(changedState.orderType
                                                            ? { orderType: changedState.orderType }
                                                            : {})
                                                    }

                                                }, () => {
                                                    this.setFiltersToLocalStorage();
                                                    this.getDronesData()
                                                })
                                            }}
                                            activities={this.state.activeTeam.isOwner && {
                                                hideDelete: true,
                                                canManage: true,
                                                onClickManage: (drone) => {
                                                    this.setState({
                                                        selectedManageDroneAccess: drone,
                                                        // selectedProjectData: { pathname: "/aerogcsenterprise/plans", state: { user, type, project, sidebarMode: this.state.sidebarMode } }
                                                    })
                                                },
                                            }}
                                        />
                                    </div>
                                </>}
                        </> : <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", height: "75vh" }}>
                            {`You dont have access to teams section of ${this.state.activeTeam?.teamName} `}
                        </div>}
                    </div>}
            </div>
        </div > : <div />
        );
    }
}

const mapStateToProps = state => {
    return {
        SubscriptionData: state.subscription.subscriptionData,
    };
};

const ConnectedDrnMgmtDrones = connect(mapStateToProps, null)(DrnMgmtDrones)
export default withRouter(ConnectedDrnMgmtDrones);